import { SexguidenSveip } from './components/sveip'
import { Poll } from './components/stilling/poll/poll'

if (!customElements.get('dh-sg-basis-sveip')) {
  customElements.define('dh-sg-basis-sveip', SexguidenSveip)
}

if (!customElements.get('dh-sg-poll')) {
  customElements.define('dh-sg-poll', Poll)
}
